// extracted by mini-css-extract-plugin
module.exports = {"yandex_error":"CaptchaWithSubmitButton_yandex_error__1SPbm","vk_error":"CaptchaWithSubmitButton_vk_error__TGVDJ"};